<template>
  <div class="header-pc">
      <div :class="['animation-text header-pc-text', work.class]">
        <p class="company-pc">{{ work.company }}</p>
        <p class="title-pc">
          <span v-for="(text, index) in work.name" :key="index">
            {{text}}
          </span>
        </p>
        <p class="description-pc">
          {{work.description}}
        </p>
      </div>
      <div class="header-pc-image">
        <img  style="width:100% ; object-fit: contain;" alt='' :src="getImageUrl(work.screenShot1)" />
      </div>
    </div>
</template>

<script>
import useRenderData from '@/composables/useRenderData';

export default {
  setup() {
    const { getImageUrl } = useRenderData('network-security');
    return {
      getImageUrl,
    };
  },
  props: {
    work: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
  .header-pc{
    background: #F1F3F4;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 114px 30px;
    .header-pc-text{
      box-sizing: border-box;
      max-width: 454px;
      margin-right: 7.5px;
    }
    .header-pc-image{
      max-width: 454px;
      margin-left: 7.5px;
      display: flex;
    }
  }
  .title-pc {
    margin-bottom: 85px;
    line-height: 45px;
    font-size: 32px;
    font-weight: bold;
    color: #222222;
    letter-spacing: 0.85px;
  }
  .company-pc, .description-pc {
    flex: 1 1 auto;
    font-size: 16px;
    line-height: 22px;
    white-space: pre-line;
    color: #222222;
    letter-spacing: 0.43px;
    font-weight: 400;
  }
  .company-pc {
    margin-bottom: 17px;
  }
  .header-text-py-77 {
    padding: 77px 0;
  }
  .header-text-py-43 {
    padding: 43.5px 0;
  }

  @media only screen and (max-width: 999px) {
    .header-pc {
      flex-direction: column;
      text-align: center;
      padding: 42px 30px 70px;
      .header-pc-text {
        width: 100%;
        max-width: 100%;
        margin-right: 0;
        margin-bottom: 40px;
      }
      .header-pc-image{
        margin-left: 0;
        height: 232px;
      }
    }
    .title-pc {
      margin-bottom: 40px;
    }
    .company-pc {
      line-height: 16px;
    }
    .description-pc {
      line-height: 24px;
    }
    .header-text-py-77 {
      padding: 0;
    }
    .header-text-py-43 {
      padding: 0;
    }
  }
</style>
